import React, { Component, RefObject } from "react";
import "./vetting_overview.css";
import { API_ENDPOINT, callApi } from "../../utils/api";
import Select from "react-select";
import {
  ToastsStore,
  ToastsContainer,
  ToastsContainerPosition,
} from "react-toasts";
import moment from "moment";
import { cloneDeep } from "lodash";
import DashUploadDocument from "../file/DashUploadDocument";
import "suneditor/dist/css/suneditor.min.css";
import DOMPurify from "dompurify";
import edit from "../../assets/images/edit.svg";
import _ from "lodash";
import isEmpty from "lodash/isEmpty";
import { toast } from "react-toastify";
import { compressPdf } from "../PdfCompress/PdfCompressor";
import TabKeyBlocker from "../Customecomponent/TabKeyBlocker";

declare var $: any;
interface AllProps {
  id: any;
  history: any;
  match: any;
  location: any;
}

interface Scrutiny {
  fod_fk: string;
  verify: string;
  nature_doc: string;
  extent: string;
  old_surevey: string;
  particulars: string;
  doc_no: string;
  date: string;
  type: string;
  ec_id: any;
  scrutiny_id: any;
  color: string;
  status: string;
  obtainedstatus: string;
  vetting_nature_of_doc: string;
  // removestatus: boolean;
}

export default class VettingOverview extends Component<AllProps> {
  scrollToRef: RefObject<HTMLDivElement> = React.createRef();
  documentFormat = {
    base: "",
    base_url: "",
    docNoYear: "",
    particular: "xerox",
    type: "",
    isValid: true,
    doc_type: "",
  };
  state = {
    bank_templates: [],
    bank_id: 0,
    realFileidfk: "",
    pdfPreview: "",
    report: "",
    download_report: "",
    docxReady: false,
    localfile_name: "",
    enableComplete: false,
    timer: 0,
    file_idfk: "",
    scrutinies: [],
    ChangeObtained: [],
    originalPresents: [],
    required: false,
    obtined: "",
    obtainedstatus: "",
    ReasonVal: false,
    lastUploadedDocument: {
      pdf: null,
      docx: null,
    },
    info: {
      qaStatus: 0,
      vetting_download_button: "0",
      borrower_name: "",
      property_owner_name: "",
      deviation_officer: "",
      rectify_officer: "",
      verify_officer: "",
      process_officer: "",
      existingFileNo: "",
      isExistingFile: "",
      app_id: "",
      doc_request: "",
      file_name: "",
      file_status: "",
      verify: "",
      report_status: "",
      pending: "",
      closed: "",
      total: "",
      bank_name: "",
      login_time: "",
      org_bank_id: "",
      productId: "",
    },
    outreason: "",
    obtained_id: "",
    obtained_type: "",
    obtained_doc_nature: "",
    rows: [],
    columns: [],
    lengthofRow: "",
    scrutinieLength: 0,
    showTitle: true,
    isloading: false,
    completeLoading: false,
    categoriesList: [],
    base: [],
    deeds: [],
    type: "",
    previewDoc: "",
    isNewFile: false,
    uploadbtn: false,
    isbtnload: false,
    editorcontent:
      "<p>All that piece and parcel of the landed property <strong>bearing Door No-##door_no##</strong> comprised in <strong>##survey_details##</strong> measuring an extent of <strong>##total_extent##</strong> in Plot No-<strong>##plot_no##</strong>, <strong>##layout##</strong> <strong>##street##</strong> of <strong>##village##</strong> <strong>Village</strong>,<strong> ##taluk## Taluk</strong>, <strong>##district## District</strong> lying within the <strong>Registration District</strong> <strong>of ##regd_district##</strong> and <strong>Sub-Registration District of ##sro##</strong> and being bounded on the\n</p><p><strong>Boundaries:-</strong>\n</p><p><strong>North ##Of / by##:</strong> #<strong>#</strong>north_directions##\n</p><p><strong>South ##Of / by##:</strong> ##south_directions##\n</p><p><strong>East ##Of / by##:</strong> ##east_directions##\n</p><p><strong>West ##Of / by##:</strong> ##west_directions##\n</p><p><strong>Within these boundaries measuring:-</strong>\n</p><p>East to West on the <strong>North Side: ##feet## feet</strong>\n</p><p>East to West on the <strong>South Side: ##feet## feet</strong>\n</p><p>South to North on the <strong>East Side: ##feet## feet</strong>\n</p><p>South to North on the <strong>West Side: ##feet## feet</strong>\n</p><p>Totally measuring of <strong>##total_extent## Square feet</strong>\n</p><p>with all easement rights and pathway<em>​</em>\n</p>",
    documentWidth: 50,
    documentHeight: 770,
    velocityEqualToMove: false,
    enableVelocity: false,
    isHightlightsLoaded: false,
    rotation: 0,
    docToPreview: false,
    highlights: [],
    isSavingSOP: false,
    docList: [],
    allDocuments: [],
    selectedDoc: "",
    sop_status: 0,
    documentbase: "",
    holdVal: false,
    holdreason: "",
    isLoading: false,
    hasUnsavedChanges: false,
    isGlobalPdfCompress: "",
    globalPdfCompressQuality: "",
    isFrontOfficePdfCompressShow: "",
    isSroEcPdfCompressQuality: "",
    isOnlineEcPdfCompressQuality: "",
  };
  document = {
    documentbase: "",
    numPages: 0,
    pageNumber: 1,
  };
  removestatus: any;
  intervalId: NodeJS.Timeout | number | null = null;

  async componentDidMount() {
    await this.fetchPdfSettings();
    await this.getTemplates();
    await this.getOriginalPresents();
    await this.getDeeds();
    setTimeout(async () => {
      await this.getFileDashboard();
    }, 1000);
    const file_id: any = localStorage.getItem("currentfileId");
    const str = file_id;
    const withoutQuotes = str && str?.replace(/"/g, "");
    this.setState({ file_idfk: withoutQuotes });
    // this.setupDragAndDrop();
    window.addEventListener("beforeunload", this._confirm);
  }

  _confirm = (e) => {
    var confirmationMessage = "o/";
    e.returnValue = confirmationMessage;
    return confirmationMessage;
  };

  setupDragAndDrop = () => {
    $(document).ready(function () {
      $(".scrity-table").sortable({
        distance: 5,
        delay: 100,
        opacity: 0.6,
        cursor: "move",
        update: function (e, ui) {
          // You can add any update logic here if needed
        },
      });
    });
  };

  fetchPdfSettings = () => {
    callApi("POST", "pdf_category.php")
      .then((res) => res.data)
      .then((response: any) => {
        if (response.result && response.data) {
          const isGlobalPdfCompress =
            response.data["Pdf document"]?.find(
              (item: any) =>
                item.name == "Pdf Compression While Uploading Document"
            )?.status == "1";
          const globalPdfCompressQuality = response.data["Pdf document"]?.find(
            (item: any) =>
              item.name == "Pdf Compression While Uploading Document"
          )?.quality;
          const isFrontOfficePdfCompressShow =
            response.data["Pdf document"]?.find(
              (item: any) => item.name == "In Query Upload Show/Hide"
            )?.status == "1";
          const isSroEcPdfCompressQuality = response.data["Pdf Category"]?.find(
            (item: any) => item.name == "SRO Encumbrance Certificate"
          )?.quality;
          const isOnlineEcPdfCompressQuality = response.data[
            "Pdf Category"
          ]?.find(
            (item: any) => item.name == "Online Encumbrance Certificate"
          )?.quality;
          this.setState({
            isGlobalPdfCompress,
            isFrontOfficePdfCompressShow,
            globalPdfCompressQuality,
            isSroEcPdfCompressQuality,
            isOnlineEcPdfCompressQuality,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        ToastsStore.error("Failed to load PDF settings");
      });
  };

  getAllDocuments = () => {
    const { isExistingFile, existingFileId }: any = this.state?.info;
    callApi("POST", "all_doc_no_list_vetting.php", {
      id: this.props.match.params.id,
      existingFileStatus: isExistingFile,
      existingFileId,
    })
      .then((res) => res.data)
      .then((response) => {
        if (response.result) {
          this.setState({ allDocuments: response.data });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  fetchtablecolumn() {
    if (this.state.bank_id) {
      const user: any = localStorage.getItem("user1");
      callApi("POST", "vetting_table_template_get.php", {
        userid: JSON.parse(user),
        bank_id: this.state.bank_id,
      })
        .then((res) => res.data)
        .then((response) => {
          let res = response.data;
          if (res != "") {
            for (let i = 0; i < res.length; i++) {
              const element = res[i];
              let lengthofrow = element.tableHeadersData.length - 1;
              this.setState({
                lengthofRow: lengthofrow,
                columns: element.tableHeadersData,
                rows: [],
              });
            }
          } else {
            this.setState({ lengthofRow: "", columns: [], rows: [] });
          }
          this.gettabledata();
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }
  updatetabledata = () => {
    const user: any = localStorage.getItem("user1");
    // Transform the state rows back to the API expected format
    const tableRowData = this.state.rows.map((row: any) => row.cells);

    callApi("POST", "vetting_row_data.php", {
      userid: JSON.parse(user),
      id: this.props.match.params.id,
      bank_id: this.state.bank_id,
      tableRowData: tableRowData,
    })
      .then((res) => res.data)
      .then((response) => {
        if (response.result == true) {
          this.setState({ hasUnsavedChanges: false });
          ToastsStore.success("Updated Successfully");
          this.getScrutinizedDocs();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // gettabledata = () => {
  //   const user: any = localStorage.getItem("user1");
  //   callApi("POST", "vetting_row_data_get.php", {
  //     userid: JSON.parse(user),
  //     id: this.props.match.params.id,
  //   })
  //     .then((res) => res.data)
  //     .then((response) => {
  //       let res = response.data;
  //       if (res != "") {
  //         for (let i = 0; i < res.length; i++) {
  //           const element = res[i];
  //           this.setState({ bank_id: element.bank_id });
  //           if (element.tableRowData != null) {
  //             this.setState({ rows: element.tableRowData });
  //           } else {
  //             this.setState({ rows: [] });
  //           }
  //         }
  //       } else {
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };

  gettabledata = () => {
    const user: any = localStorage.getItem("user1");
    callApi("POST", "vetting_row_data_get.php", {
      userid: JSON.parse(user),
      id: this.props.match.params.id,
    })
      .then((res) => res.data)
      .then((response) => {
        if (response.result && response.data.length > 0) {
          const element = response.data[0]; // Take first element
          // this.setState({ bank_id: element.bank_id });

          // Transform API data to match expected row structure
          const formattedRows = element.tableRowData
            ? element.tableRowData.map((row) => ({
                cells: Array.isArray(row) ? row : [], // Ensure it's an array
                isEditing: false,
                previousValues: [],
              }))
            : [];

          this.setState({ rows: formattedRows });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  incrementTimer = () => {
    const { timer } = this.state;
    this.setState({ timer: timer + 1 });
  };

  getTemplates = () => {
    callApi("POST", "file_dash_temp.php")
      .then((res) => res.data)
      .then((response) => {
        let banks = response.data;
        const vetting = banks.filter(
          (item) => item.name.split(" ").pop() === "Vetting"
        );
        this.setState({ bank_templates: vetting });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getOriginalPresents = () => {
    callApi("POST", "original_get.php")
      .then((res) => res.data)
      .then((response) => {
        if (response.data && response.data.length) {
          // const state = this.state;
          const originalPresents = response.data;
          this.setState({ originalPresents });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getFileDashboard = () => {
    callApi("POST", "vetting_file_dash.php", {
      id: this.props.match.params.id,
    })
      .then((res) => res.data)
      .then((response) => {
        const state = response.data;

        if (response.data && response.data.length) {
          state.info = response.data[0];
          state.bank_id = state?.info?.bank_temp;
          state.sop_status = state?.info?.sop_status;
          if (state.bank_id == 0) {
            toast.error("Please Select Your Bank Format");
            this.setState({ overViewShow: true });
          }
        }
        this.setState({ ...state }, () => {
          this.getDocList();
          this.getAllDocuments();
          this.getScrutinizedDocs();
          this.fetchtablecolumn();
        });
        let bankTemp: any = this.state.bank_templates.find((get: any) => {
          if (get.id === this.state.bank_id) {
            localStorage.setItem("vettingBankTemplateName", get.name);
            localStorage.setItem("vettingBankTemplatemode", get.mode);
          }
        });
        $(document).ready(function () {
          $("#simpletable").DataTable();
        });
        // this.scrutinyReport();
      })
      .catch((err) => {
        console.log(err);
      });
  };
  handleChange = (e, propName?, fieldType?) => {
    let fieldName = fieldType === "singleselect" ? propName : e.target.name;
    let fieldValue = fieldType === "singleselect" ? e.value : e.target.value;
    this.setState({ [fieldName]: fieldValue, sop_status: e.sop_status });
    if (fieldName !== "reason") {
      this.saveTemplate(fieldValue);
    }
  };
  saveTemplate = (val) => {
    callApi("POST", "vetting_bank_temp_save.php", {
      id: this.props.match.params.id,
      bank_id: val,
    })
      .then((res) => res.data)
      .then((response) => {
        this.setState({ workfileEnable: false });
        localStorage.removeItem("BankTemplate");
        localStorage.removeItem("vettingOverviewDocument");
        this.getFileDashboard();
      })
      .catch((err) => {
        console.log(err);
      });
  };
  handleChangeobtained = (e, index, modal, propName?, fieldType?) => {
    this.setState({ outreason: "" });
    const id = modal.type === "scrutiny" ? modal.scrutiny_id : modal.ec_id;
    this.setState({ obtained_id: id });
    this.setState({ obtained_type: modal.type });
    this.setState({ obtained_doc_nature: e.id });
    callApi("POST", "vetting_doc_scrutinize_update.php", {
      id: id,
      vetting_type: modal.type,
      vetting_nature_of_doc: e.id,
      vetting_reason: this.state.outreason,
    })
      .then((res) => res.data)
      .then((response) => {
        this.setState({ outreason: "" });
        this.getScrutinizedDocs();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  closeModal(): void {
    $("#modal-reason").modal("hide");
    this.setState({ selectVal: false });
    this.setState({ outreason: "" });
    this.setState({ obtainedstatus: "" });
    this.getScrutinizedDocs();
  }
  ReasonUpdate(): void {
    if (this.state.outreason == "") {
      this.setState({ ReasonVal: true });
    } else {
      this.setState({ ReasonVal: false });
      $("#modal-reason").modal("hide");
      this.setState({ selectVal: false });
      callApi("POST", "vetting_doc_scrutinize_update.php", {
        id: this.state.obtained_id,
        vetting_type: this.state.obtained_type,
        // verify: modal.verify === "UnVerified" ? 1 : 0
        vetting_nature_of_doc: this.state.obtained_doc_nature,
        vetting_reason: this.state.outreason,
      })
        .then((res) => res.data)
        .then((response) => {
          this.setState({ outreason: "" });
          this.getScrutinizedDocs();
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  onchange = (e: any) => {
    this.setState({
      [e.target.name]: e.target.value.replace(/\s+/g, " ").trim(),
      ReasonVal: false,
    });
  };

  scrutinyReport = () => {
    if (this.state.hasUnsavedChanges) {
      const confirmLeave = window.confirm(
        "If you have unsaved changes. Do you want to leave without saving?"
      );
      if (!confirmLeave) {
        return;
      }
    }

    if (
      this.state.sop_status == 1 &&
      this.state.docList &&
      this.state.docList.length > 0
    ) {
      const activeDocsLength = this.state.docList.filter(
        (doc: any) => doc.inactive == 0
      ).length;
      const savedDocsLength = this.state.docList.filter(
        (doc: any) => doc.submit == 1 && doc.inactive == 0
      ).length;
      const isValid = activeDocsLength == savedDocsLength;
      console.log(
        "activeDocsLength",
        activeDocsLength,
        "savedDocsLength",
        savedDocsLength,
        "isValid",
        isValid
      );
      if (!isValid) {
        ToastsStore.error("Please type all SOP documents");
        return;
      }
    }

    if (this.state.bank_id) {
      this.setState({
        isloading: true,
        report: "",
        timer: 0,
        docxReady: false,
        download_report: "",
        enableComplete: false,
      });
      if (this.intervalId) {
        clearInterval(this.intervalId as NodeJS.Timeout);
      }

      this.intervalId = setInterval(() => {
        this.incrementTimer();
      }, 1000);
      $(".loader").show();
      const user: any = localStorage.getItem("user");
      const userId = user ? JSON.parse(user)["userId"] : "";
      callApi("POST", "template/tests/scrutiny_report_vetting.php", {
        file_idfk: this.props.match.params.id,
        check: false,
        userId,
        bank_id: this.state.bank_id,
      })
        .then((res) => res.data)
        .then((response) => {
          if (response.result && response.data) {
            const generatedFile = response.file ? String(response.file) : "";
            this.setState({
              report: response.data,
              isloading: false,
              localfile_name: response.file_name,
              download_report: generatedFile,
              docxReady: !!generatedFile,
            });
            const url = response?.file;

            this.makeApiCall(url);

            // $("#root").unbind();
            if (this.scrollToRef.current !== null) {
              this.scrollToRef.current.scrollIntoView({ behavior: "smooth" });
            }
            if (this.intervalId) {
              clearInterval(this.intervalId as NodeJS.Timeout);
              this.intervalId = null;
            }
            this.setState({ timer: 0 });
            $(".loader").hide();
          } else {
            if (this.intervalId) {
              clearInterval(this.intervalId as NodeJS.Timeout);
              this.intervalId = null;
            }
            this.setState({
              enableComplete: false,
              isloading: false,
              docxReady: false,
              download_report: "",
            });
            $(".loader").hide();
            ToastsStore.error(response.message || "Document not generated. Please try after sometime.");
          }
        })
        .catch(() => {
          if (this.intervalId) {
            clearInterval(this.intervalId as NodeJS.Timeout);
            this.intervalId = null;
          }
          this.setState({
            isloading: false,
            docxReady: false,
            download_report: "",
          });
          $(".loader").hide();
          ToastsStore.error("Try Again.");
        });
    } else {
      ToastsStore.error("Please Select the Bank");
    }
  };

  makeApiCall = (url) => {
    let timeoutId;

    fetch(url)
      .then((response) => {
        console.log(`Status Code: ${response.status}`);
        if (response.ok && response.status == 200) {
          console.log("URL is reachable.", response);
          // If status is 200, clear the timeout
          clearTimeout(timeoutId);
          this.setState({ enableComplete: true });
        } else {
          console.log("URL is not reachable.", response);
          // If status is 404, set the timeout for the next call
          this.setState({ enableComplete: false });
          timeoutId = setTimeout(this.makeApiCall, 5000);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  modifyScrutinyVerification = (modal) => {
    callApi("POST", "scrutiny_verify.php", {
      id: modal.type === "scrutiny" ? modal.scrutiny_id : modal.ec_id,
      type: modal.type,
      verify: modal.verify === "UnVerified" ? 1 : 0,
    })
      .then((res) => res.data)
      .then((response) => {
        this.getScrutinizedDocs();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  goToFile = (file) => {
    if (this.state.hasUnsavedChanges) {
      const confirmLeave = window.confirm(
        "If you have unsaved changes. Do you want to leave without saving?"
      );
      if (!confirmLeave) {
        return;
      }
    }

    const currectFileId = JSON.stringify(this.props.match.params.id);
    const vettingFileId = localStorage.getItem("vetting_takenfile_id");
    const isShowButton = vettingFileId && vettingFileId === currectFileId;
    const { isExistingFile, existingFileId }: any = this.state?.info;

    this.props.history.push({
      pathname: `/${file.type}/${existingFileId}/${file.fod_fk}/3`,
      state: { hash: "vetting", isShowButton: isShowButton },
      hash: "#vetting",
    });
  };

  getScrutinizedDocs = () => {
    const { isExistingFile, existingFileId }: any = this.state?.info;
    if (isExistingFile == "1") {
      callApi("POST", "vetting_doc_scrutinize_list.php", {
        id: existingFileId,
      })
        .then((res) => res.data)
        .then((response) => {
          if (response.result) {
            const scr = response.data.filter((itm) => itm.type === "scrutiny");
            const ec = response.data.filter((itm) => itm.type === "ec-form");
            if (scr && scr.length) {
              scr.forEach((doc, index) => {
                doc.index = index + 1;
              });
            }
            if (ec && ec.length) {
              ec.forEach((doc, index) => {
                doc.index = index + 1;
              });
            }
            const scrutinies = scr.concat(ec);
            let scrutinieLength = scrutinies.length;
            this.setState({ scrutinies });
            this.setState({ scrutinieLength });
          } else {
            this.setState({ scrutinies: [] });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  handleChangeremovestatus = (event, scr) => {
    const isChecked = event.target.checked;
    if (isChecked) {
      this.removestatus = 1;
    } else {
      this.removestatus = 0;
    }
    const scrutinies = this.state.scrutinies.map((scrutinies: any) => {
      if (
        scrutinies.scrutiny_id === scr.scrutiny_id &&
        scrutinies.type == "scrutiny"
      ) {
        return {
          ...scrutinies,
          remove_status: JSON.stringify(this.removestatus),
        };
      } else if (
        scrutinies.ec_id === scr.ec_id &&
        scrutinies.type == "ec-form"
      ) {
        return {
          ...scrutinies,
          remove_status: JSON.stringify(this.removestatus),
        };
      }
      return scrutinies;
    });
    this.setState({ scrutinies });
  };

  handleSubmit = () => {
    const checkedStatus = this.state.scrutinies.filter(
      (scrutinie: any) => scrutinie?.remove_status
    );
    if (checkedStatus && checkedStatus?.length > 0) {
      callApi("POST", "vetting_doc_scrutinize_remove_update.php", {
        remove_status: checkedStatus,
      })
        .then((res) => res.data)
        .then((response) => {
          if (response.success == true) {
            this.updatetabledata();
            ToastsStore.success("Updated Successfully");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      this.updatetabledata();
    }
  };

  vettingcompleteupdatetime() {
    var now = new Date();
    var date = now.toLocaleDateString();
    var time = now.toLocaleTimeString();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const seconds = now.getSeconds();
    const currenttime = `${hours}:${minutes}:${seconds}`;
    const currentdate = moment(date).format("YYYY-MM-DD");
    const loginuser: any = localStorage.getItem("user1");
    let req = {
      vetting_completed_time: currenttime,
      vetting_completed_date: currentdate,
      vetting_completed_by: JSON.parse(loginuser),
      id: this.props.match.params.id,
    };
    callApi("POST", "time_update.php", req)
      .then((res) => res.data)
      .then((response) => {});
  }

  updateBillVettingComplete(status) {
    if (this.state.hasUnsavedChanges) {
      const confirmLeave = window.confirm(
        "If you have unsaved changes. Do you want to leave without saving?"
      );
      if (!confirmLeave) {
        return;
      }
    }

    this.setState({ showTitle: true, completeLoading: true });
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";

    let obj: any = {
      fileId: this.props.match.params.id,
      reason: "Vetting Completed",
      createdBy: userId,
      // file: ,
      errorTypes: ["1", "2"],
      errorSection: ["1", "2"],
      serverLocalFileName: this.state.localfile_name,
    };

    callApi("POST", "template/tests/vetting_upload_log.php", obj)
      .then((res) => res.data)
      .then((result) => {
        if (result.status == 200) {
          this.handleVettingComplete(status);
        } else {
          this.setState({ showTitle: true, completeLoading: false });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ showTitle: true, completeLoading: false });
      });
  }

  handleVettingComplete = (status) => {
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    callApi("POST", "bill_vetting_complete.php", {
      file_id: this.props.match.params.id,
      vettingby: userId,
      status,
    })
      .then((res) => res.data)
      .then((result) => {
        if (result.result == true) {
          this.setState({ showTitle: false, completeLoading: false });
          $("#vetting-complete").modal("hide");
          this.props.history.push("/vetting-process");
          // this.vettingcompleteupdatetime();
        } else {
          this.setState({ showTitle: false, completeLoading: false });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ showTitle: false, completeLoading: false });
      });
  };

  close = () => {
    $("#processComplete").modal("hide");
  };

  downloadGeneratedDocx = () => {
    const url = this.state.download_report;
    if (!this.state.docxReady || !url) {
      return;
    }
    const fromUrl = decodeURIComponent(String(url).split("/").pop() || "");
    const fileName =
      fromUrl || `${this.state.localfile_name || "vetting-report"}.docx`;
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  //Download docs from external api
  downloadDocs = () => {
    callApi("POST", "template/tests/shell_vetting.php", {
      id: this.props.match.params.id,
      // responseType: "blob",
    })
      .then((res) => res.data)
      .then((response) => {
        //ToastsStore.success("Downloaded Successfully!");
        window.open(
          API_ENDPOINT +
            "template/tests/shell_vetting.php?id=" +
            this.props.match.params.id,
          "_self"
        );
      });
  };

  // handleChangetable(
  //   event: React.ChangeEvent<HTMLInputElement>,
  //   rowIndex: number,
  //   columnIndex: number
  // ): void {
  //   const { rows } = this.state;
  //   const newRows = [...rows] as string[][];
  //   // Check if rowIndex is a valid index in newRows
  //   if (newRows[rowIndex] || newRows[columnIndex]) {
  //     newRows[rowIndex][columnIndex] = event.target.value;
  //     this.setState({ rows: newRows });
  //   }
  // }

  handleChangetable = (
    event: React.ChangeEvent<HTMLInputElement>,
    rowIndex: number,
    columnIndex: number
  ) => {
    const newValue = event.target.value;
    this.setState((prevState: any) => {
      const updatedRows = [...prevState.rows];
      const updatedRow = {
        ...updatedRows[rowIndex],
        cells: [...updatedRows[rowIndex].cells],
      };
      updatedRow.cells[columnIndex] = newValue;
      updatedRows[rowIndex] = updatedRow;
      return { rows: updatedRows, hasUnsavedChanges: true };
    });
  };

  // handleAddRow = () => {
  //   const { rows, columns } = this.state as unknown as {
  //     rows: never[][];
  //     columns: string[];
  //   };
  //   const newRow = [] as string[];
  //   for (let i = 0; i < columns.length - 1; i++) {
  //     newRow.push("");
  //   }
  //   newRow.push(""); // add an empty value for the select box
  //   this.setState({ rows: [...rows, newRow] });
  // };

  handleSelectboxChange = (selectedOption, rowIndex) => {
    const { rows } = this.state;
    const newRows = [...rows] as string[][];
    // Check if rowIndex is a valid index in newRows
    if (newRows[rowIndex]) {
      newRows[rowIndex][newRows[rowIndex].length - 1] = selectedOption.value;
      this.setState({ rows: newRows });
    }
  };

  handleRemoveRow = (index) => {
    const { rows } = this.state;
    const newRows = [...rows];
    newRows.splice(index, 1);
    this.setState({ rows: newRows });
  };

  handleAddColumn = () => {
    const { rows, columns } = this.state;
    const newColumn = "";
    const newRows = rows.map((row) => [...row, newColumn]);
    this.setState({ rows: newRows, columns: [...columns, newColumn] });
  };

  handleRemoveColumn = (index) => {
    const { rows, columns } = this.state;
    const newColumns = [...columns];
    newColumns.splice(index, 1);
    const newRows = rows.map((row) => {
      const newRow = [...row];
      newRow.splice(index, 1);
      return newRow;
    });
    this.setState({ rows: newRows, columns: newColumns });
  };

  validateRequiredFileds = (e) => {
    if (this.state.base && this.state.base.length > 0) {
      this.uploadFiles();
    } else {
    }
  };

  uploadFiles = () => {
    const isValid = this.validateDocuments();
    if (!isValid) {
      // Show error message or handle validation error
      ToastsStore.error("Please fill in all fields for this document");
      return;
    } else {
      this.setState({ isbtnload: true, uploadbtn: true });
      const user: any = localStorage.getItem("user");
      const userId = user ? JSON.parse(user)["userId"] : "";
      callApi("POST", "vetting_doc_file_upload.php", {
        id: this.props.match.params.id,
        uploadfile: this.state.base,
        userId,
      })
        .then((res) => res)
        .then((response) => {
          const responseData = response.data;
          if (responseData.success === true) {
            this.setState({ isbtnload: false, uploadbtn: false, base: [] });
            $("#upload-modal").modal("hide");
            ToastsStore.success("File(s) Uploaded Successully");
            this.getDocList();
            this.getAllDocuments();
          } else {
            this.setState({ uploadbtn: false, isbtnload: false });
            ToastsStore.success("File(s) Not Uploaded");
          }
        })
        .catch((err) => {
          this.setState({ isbtnload: false, uploadbtn: false });
        });
    }
  };

  validateDocuments = () => {
    let base: any = this.state.base;
    let isValid = true;
    const invalidDocuments = [
      "26",
      "27",
      "36",
      "35",
      "38",
      "103",
      "78",
      "5",
      "Online Encumbrance Certificate",
    ];
    for (let i = 0; i < base.length; i++) {
      const document = base[i];

      if (invalidDocuments.includes(document.doc_type)) {
        base[i].isValid = true;
      } else {
        if (
          document.type == "deed" ||
          document.type == "mother_doc" ||
          document.type == "title_deed" ||
          document.type == "ec_doc"
        ) {
          if (
            !document.docNoYear ||
            !document.doc_type ||
            !document.type ||
            !document.particular ||
            !document.base
          ) {
            isValid = false;
            base[i].isValid = false;
          } else {
            base[i].isValid = true;
          }
        } else if (
          document.type == "rev_rec_doc" ||
          document.type == "sale_agreement"
        ) {
          if (
            !document.doc_type ||
            !document.type ||
            !document.particular ||
            !document.base
          ) {
            isValid = false;
            base[i].isValid = false;
          } else {
            base[i].isValid = true;
          }
        } else {
          isValid = false;
          base[i].isValid = false;
        }
      }
    }
    return isValid;
  };

  getDeeds = () => {
    callApi("POST", "deed_master_get.php", { category: this.state.type })
      .then((res) => res.data)
      .then((response) => {
        if (response.data && response.data.length) {
          const deeds = response.data;
          this.setState({ deeds });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getCategories = () => {
    callApi("POST", "category.php")
      .then((res) => res.data)
      .then((response) => {
        this.setState({ categoriesList: response.data });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  addUploadDocument = () => {
    let baseArray = cloneDeep(this.state.base);
    baseArray.push(this.documentFormat);
    this.setState({ base: baseArray });
  };

  deleteDocumentDetails = (index) => {
    const baseArray = cloneDeep(this.state.base);
    baseArray.splice(index, 1);
    this.setState({ base: baseArray });
  };

  deleteFile = (index) => {
    const baseArray = cloneDeep(this.state.base);
    baseArray[index] = {
      ...baseArray[index],
      details: {},
      base: "",
    };
    this.setState({ base: baseArray });
  };

  handleDocumentDetailsChange = (value, index, key) => {
    const invalidDocuments = [
      "26",
      "27",
      "36",
      "35",
      "38",
      "103",
      "78",
      "5",
      "Online Encumbrance Certificate",
    ];
    if (key == "docNoYear") {
      const isValidInput = /^[0-9/-]*$/.test(value);

      if (!isValidInput) {
        console.error(
          "Invalid input. Please enter only numeric characters, slash, or hyphen."
        );
        return;
      }
      let baseArray = cloneDeep(this.state.base);
      baseArray[index] = {
        ...baseArray[index],
        [key]: value,
      };
      this.setState({ base: baseArray });
    } else {
      let baseArray = cloneDeep(this.state.base);
      if (key == "doc_type") {
        if (invalidDocuments.includes(value)) {
          baseArray[index] = {
            ...baseArray[index],
            docNoYear: "",
          };
          this.setState({ base: baseArray });
        }
      }

      baseArray[index] = {
        ...baseArray[index],
        [key]: value,
      };
      this.setState({ base: baseArray });
    }
  };

  handleDocumentFilesChange1 = async (value, index, parentDetails) => {
    const { isGlobalPdfCompress } = this.state;
    this.setState({ isbtnload: true });
    try {
      const fileObj = value.fileList[0];

      // Get base64 (some upload libraries provide directly, some require conversion)
      let base64 = fileObj.base64 || value.base64;

      // If not PDF → directly upload
      if (!fileObj?.type?.includes("pdf")) {
        return this.uploadAndSync(value, base64, index, null);
      }

      // If compression disabled → upload original
      if (
        !isGlobalPdfCompress ||
        parentDetails.isPdfCompress != "on" ||
        fileObj.alreadyCompressed
      ) {
        return this.uploadAndSync(value, base64, index, null);
      }

      // Get quality settings
      const {
        deeds,
        globalPdfCompressQuality,
        isSroEcPdfCompressQuality,
        isOnlineEcPdfCompressQuality,
      }: any = this.state;

      let quality =
        parentDetails.doc_type === "SRO Encumbrance Certificate"
          ? isSroEcPdfCompressQuality || globalPdfCompressQuality
          : parentDetails.doc_type === "Online Encumbrance Certificate"
          ? isOnlineEcPdfCompressQuality || globalPdfCompressQuality
          : deeds?.find((d: any) => d.id === parentDetails.doc_type)?.quality ||
            globalPdfCompressQuality;

      // Compress PDF
      const compressResponse = await compressPdf({
        base64: base64,
        quality,
      });

      // Prevent double compression
      fileObj.alreadyCompressed = true;

      // Upload compressed output
      this.uploadAndSync(
        value,
        compressResponse.compressedBase64,
        index,
        compressResponse
      );
    } catch (err) {
      console.error("Error in handleDocumentFilesChange1:", err);
      ToastsStore.error("File processing failed");
    }
  };

  uploadAndSync = (files, base64, index, compressResponse) => {
    // Update UI immediately
    const baseArray = cloneDeep(this.state.base);
    const fileObj = files.fileList[0];

    baseArray[index] = {
      ...baseArray[index],
      base: fileObj.name,
      base_url: base64,
      originalSize: compressResponse?.originalSize || "",
      compressedSize: compressResponse?.compressedSize || "",
    };

    this.setState({ base: baseArray, isbtnload: false });
  };

  // handleDocumentFilesChange1 = (value, index, key) => {
  //   let baseArray = cloneDeep(this.state.base);
  //   baseArray[index] = {
  //     ...baseArray[index],
  //     base: value.fileList[0].name,
  //     base_url: value.base64,
  //   };
  //   this.setState({ base: baseArray });
  // };

  previewDoc = (file) => {
    this.setState({ previewDoc: file });
  };

  closeuploadfile = () => {
    this.setState({ base: [] });
  };

  setContent(e) {
    const cleanHTML = DOMPurify.sanitize(e, {
      FORBID_TAGS: ["em"], // Forbid <em> tag but allow other safe tags
    });
    this.setState({ editorcontent: cleanHTML });
  }

  rotate = () => {
    let newRotation = this.state.rotation + 90;
    if (newRotation >= 360) {
      newRotation = -360;
    }
    this.setState({ rotation: newRotation });
  };
  onHighlightsChange = (highlights) => {
    this.setState({ highlights });
  };

  saveSOP = () => {
    this.setState({ isSavingSOP: true });
    callApi("POST", "general_details1.php", {
      highlights: this.state.highlights,
      file_id: this.props.match.params.id,
      editorcontent: this.state.editorcontent,
    })
      .then((res) => res.data)
      .then((response) => {})
      .catch((err) => {
        console.log(err);
        this.setState({ isSavingSOP: false });
      })
      .finally(() => {
        this.setState({ isLoading: false });
      });
  };

  getDocList = () => {
    const props: any = this.props;
    const { isExistingFile, existingFileId }: any = this.state?.info;
    callApi("POST", "doc_list_get_vetting.php", {
      id: props.match.params.id,
      existingFileStatus: "",
      existingFileId: "",
    })
      .then((res) => res.data)
      .then((response) => {
        if (response.data && response.data.length) {
          const titleDeed = _.find(response.data, ["type", "Title Deed"]);
          const saleAgreement = _.find(response.data, [
            "type",
            "Sale Agreement",
          ]);

          const combinedDocs = [
            ...(titleDeed?.documents || []),
            ...(saleAgreement?.documents || []),
          ];

          this.setState({ docList: combinedDocs });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  viewDocument = (e) => {
    const selectedValue = e?.target?.value;
    const selectedIndex = e?.target?.options?.selectedIndex;
    const selectedId = e?.target?.options?.[selectedIndex]
      ?.getAttribute("data-id")
      ?.split("|")?.[0];
    const existingStatus = e?.target?.options?.[selectedIndex]?.getAttribute(
      "data-existing-status"
    );

    if (selectedId) {
      const endpoint =
        existingStatus == "1" ? "getbaseby_id.php" : "getbaseby_id_vetting.php";
      callApi("POST", endpoint, { id: selectedId })
        .then((res) => res.data)
        .then((response) => {
          if (response.result == true) {
            if (response.data && response.data.length) {
              const document = this.document;
              if (
                response.data &&
                response.data?.[0]?.base &&
                response.data[0].base?.length > 0
              ) {
                document.documentbase = response.data[0].base[0].base;
              }
              this.setState({ ...document, selectedDoc: selectedValue });
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  handleSaveRow = (rowIndex: number): void => {
    const rows: any = [...this.state.rows]; // Clone the current rows
    if (rows[rowIndex]) {
      rows[rowIndex] = {
        ...rows[rowIndex],
        isEditing: false, // Set isEditing to false
      };
      this.setState({ rows });
    }
  };

  handleCancelEdit = (rowIndex: number): void => {
    this.setState((prevState: any) => {
      const rows = [...prevState.rows];

      // Ensure we have previous values to revert to
      if (rows[rowIndex]?.previousValues) {
        rows[rowIndex] = {
          cells: [...rows[rowIndex].previousValues], // Restore previous cell values
          isEditing: false, // Exit edit mode
          previousValues: [], // Clear previous values
        };
      } else {
        // If no previous values, just exit edit mode
        rows[rowIndex] = {
          ...rows[rowIndex],
          isEditing: false,
        };
      }

      return { rows };
    });
  };

  handleEditRow = (rowIndex: number): void => {
    this.setState((prevState: any) => {
      const rows = [...prevState.rows];
      rows[rowIndex] = {
        ...rows[rowIndex],
        isEditing: true,
        previousValues: [...rows[rowIndex].cells], // Store current cells as array
      };
      return { rows };
    });
  };

  // Example: handleAddRow
  handleAddRow = () => {
    this.setState((prevState: any) => ({
      rows: [
        ...prevState.rows,
        {
          cells: Array(prevState.columns.length).fill(""),
          isEditing: false,
          previousValues: [],
        },
      ],
    }));
  };

  holdFile = () => {
    this.setState({ holdVal: true });
    const props: any = this.props;
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    const { holdreason, holdVal } = this.state;
    if (holdreason != "" && holdVal) {
      this.setState({ isLoading: true });
      const obj = {
        file_id: props.match.params.id,
        hold_by: userId,
        reason: holdreason,
      };
      callApi("POST", "vetting_hold_file.php", obj)
        .then((res) => res.data)
        .then((response) => {
          if (response.statuscode == 200) {
            $("#holdModal").modal("hide");
            localStorage.removeItem("currentfileId");
            ToastsStore.success(response.message);
            this.setState({ holdVal: false, holdreason: "", isLoading: false });
            this.props.history.push("/vetting-process");
            // this.verificationtime("hold");
          } else {
            ToastsStore.error(response.message);
          }
        });
    } else {
      ToastsStore.error("Please type reason");
    }
  };

  render() {
    const { isExistingFile, existingFileId }: any = this.state?.info;
    const currectFileId = JSON.stringify(this.props.match.params.id);
    const vettingFileId = localStorage.getItem("vetting_takenfile_id");
    const isShowButton = vettingFileId && vettingFileId == currectFileId;
    const {
      status: vettingStatus,
      showTitle,
      timer,
      ReasonVal,
      scrutinies,
      rows,
      columns,
      docList,
    }: any = this.state;
    const user: any = localStorage.getItem("user");
    const role_label = user ? JSON.parse(user)["role_label"] : "";
    const filterTemp =
      role_label != "Admin" && role_label != "Super Admin"
        ? this.state.bank_templates.filter(
            (temp: any) =>
              temp?.bank_id === this.state?.info?.org_bank_id &&
              temp?.product_id === this.state?.info?.productId
          )
        : this.state.bank_templates;
    const banktemplatesoption = [
      // { value: "", label: "All" },
      ...filterTemp,
    ];
    return (
      // <div className="pcoded-main-container">
      //   <div className="pcoded-wrapper">
      <div className="pcoded-content">
        <ToastsContainer
          store={ToastsStore}
          position={ToastsContainerPosition.TOP_RIGHT}
        />
        <div className="pcoded-inner-content">
          <div className="main-body">
            <div className="page-wrapper">
              <div className="row">
                <div className="overview-body">
                  <div className="overview-main">
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="d-flex">
                          <h5 style={{ fontSize: "15px" }}>
                            File No - {this.state.info.file_name}
                          </h5>
                          <br />
                          <h5 style={{ marginLeft: "1%", fontSize: "15px" }}>
                            |
                          </h5>
                          <h5 style={{ marginLeft: "1%", fontSize: "15px" }}>
                            Login Date - {this.state.info.login_time}
                          </h5>
                          <h5 style={{ marginLeft: "1%", fontSize: "15px" }}>
                            |
                          </h5>
                          <h5 style={{ marginLeft: "1%", fontSize: "15px" }}>
                            Bank Name - {this.state.info.bank_name}
                          </h5>
                        </div>
                      </div>
                    </div>
                    {this.state?.info?.isExistingFile == "1" && (
                      <div className="row">
                        <div
                          className="col-md-7 d-flex"
                          style={{ marginTop: "1%" }}
                        >
                          <h5 style={{ fontSize: "15px" }}>
                            PO - {this.state.info.process_officer}
                          </h5>
                          <h5 style={{ marginLeft: "1%", fontSize: "15px" }}>
                            |
                          </h5>
                          <h5 style={{ marginLeft: "1%", fontSize: "15px" }}>
                            VO - {this.state.info.verify_officer}
                          </h5>
                          <h5 style={{ marginLeft: "1%", fontSize: "15px" }}>
                            |
                          </h5>
                          <h5 style={{ marginLeft: "1%", fontSize: "15px" }}>
                            DO - {this.state.info.deviation_officer}
                          </h5>
                          <h5 style={{ marginLeft: "1%", fontSize: "15px" }}>
                            |
                          </h5>
                          <h5 style={{ marginLeft: "1%", fontSize: "15px" }}>
                            RO - {this.state.info.rectify_officer}
                          </h5>
                          {this.state?.info?.existingFileNo != "" && (
                            <>
                              <h5
                                style={{ marginLeft: "1%", fontSize: "15px" }}
                              >
                                |
                              </h5>
                              <h5
                                style={{ marginLeft: "1%", fontSize: "15px" }}
                              >
                                Existing File No -{" "}
                                {this.state.info.existingFileNo}
                              </h5>
                            </>
                          )}
                        </div>
                      </div>
                    )}
                    <div className="row">
                      <div
                        className="col-md-6 d-flex"
                        style={{ marginTop: "1%" }}
                      >
                        <h5 style={{ fontSize: "15px" }}>
                          Property Owner Name -{" "}
                          <span className="bold">
                            {this.state.info.property_owner_name}
                          </span>
                        </h5>
                        <h5 style={{ marginLeft: "1%", fontSize: "15px" }}>
                          |
                        </h5>
                        <h5 style={{ marginLeft: "1%", fontSize: "15px" }}>
                          Borrower Name -{" "}
                          <span className="bold">
                            {this.state.info.borrower_name}
                          </span>
                        </h5>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 template-select">
                        <button
                          className="btn btn-danger btnupload float-right"
                          data-toggle="modal"
                          data-target="#holdModal"
                          style={{
                            marginTop: "5px",
                          }}
                        >
                          Hold
                        </button>
                        <button
                          className="ml2 btn btn-primary btnupload float-right"
                          data-toggle="modal"
                          data-target="#upload-modal"
                          onClick={() => this.getCategories()}
                        >
                          Upload
                        </button>
                        <button
                          onClick={() => {
                            const fileurl: any = localStorage.getItem("url");
                            if (fileurl) {
                              this.props.history.push(`${fileurl}`);
                              localStorage.removeItem("url");
                              localStorage.removeItem("thisPopup");
                              localStorage.removeItem("isPopupFromWIP");
                              localStorage.removeItem("currentfileId");
                            } else {
                              this.props.history.push("/vetting-process");
                            }
                          }}
                          className="btn btn-square float-right"
                          style={{
                            color: "black",
                            border: "1px solid black",
                            borderRadius: "5px",
                            marginTop: "5px",
                          }}
                        >
                          Back
                        </button>

                        <div
                          className="float-right"
                          style={{ width: "20em", margin: "5px 2% 0 0" }}
                        >
                          {this.state.bank_templates &&
                            this.state.bank_templates.length > 0 &&
                            this.state.bank_templates.map((opt: any) => {
                              opt.label = `${opt.name}-${opt.bank_name}-${opt.product_name}`;
                              opt.value = opt.id;
                            }) && (
                              <Select
                                options={banktemplatesoption}
                                name="bank_id"
                                value={this.state.bank_templates.find(
                                  (o: any) => o.value === this.state.bank_id
                                )}
                                onChange={(e) =>
                                  this.handleChange(
                                    e,
                                    "bank_id",
                                    "singleselect"
                                  )
                                }
                              />
                            )}
                        </div>
                      </div>
                    </div>

                    {!isEmpty(this.state.bank_id) &&
                      this.state.bank_id != 0 && (
                        <>
                          {this.state.sop_status == 1 && (
                            <div
                              className="container-fluid"
                              style={{ margin: "20px 0px" }}
                            >
                              <div className="row">
                                <div className="col-lg-12">
                                  <div className="mt-10">
                                    <h6>
                                      <strong>Description of Property</strong>
                                    </h6>
                                    <div className="dt-responsive table-responsive">
                                      <table
                                        id="bank-files-table"
                                        className="table nowrap"
                                      >
                                        <thead>
                                          <tr>
                                            <th>S.No</th>
                                            <th>Doc Type</th>
                                            <th className="text-center">
                                              As Per Doc No
                                            </th>
                                            <th className="text-center">
                                              Action
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {docList && docList.length > 0 ? (
                                            docList.map((item: any, index) => (
                                              <tr
                                                key={index}
                                                className="cursor-pointer"
                                                style={{
                                                  background: item.color,
                                                }}
                                              >
                                                <th>{index + 1}</th>
                                                <th>
                                                  {item.doc_type}{" "}
                                                  {item.inactive == 1 &&
                                                    "- (Not Related)"}
                                                </th>
                                                <th className="text-center">
                                                  {item.document_no}
                                                </th>
                                                <th
                                                  className="text-center"
                                                  onClick={() => {
                                                    if (
                                                      this.state
                                                        .hasUnsavedChanges
                                                    ) {
                                                      const confirmLeave =
                                                        window.confirm(
                                                          "If you have unsaved changes. Do you want to leave without saving?"
                                                        );
                                                      if (!confirmLeave) {
                                                        return;
                                                      }
                                                    }
                                                    const currectFileId =
                                                      JSON.stringify(
                                                        this.props.match.params
                                                          .id
                                                      );
                                                    const vettingFileId =
                                                      localStorage.getItem(
                                                        "vetting_takenfile_id"
                                                      );
                                                    const isShowButton =
                                                      vettingFileId &&
                                                      vettingFileId ===
                                                        currectFileId;
                                                    this.props.history.push({
                                                      pathname: `/vetting-general-detail/${this.props.match.params.id}/${item.file_id}/${isExistingFile}/${existingFileId}/${item.existingDocId}`,
                                                      state: {
                                                        hash: "Verify",
                                                        isShowButton:
                                                          isShowButton,
                                                      },
                                                      hash: "#Vetting",
                                                    });
                                                  }}
                                                >
                                                  <img src={edit} alt="edit" />
                                                </th>
                                              </tr>
                                            ))
                                          ) : (
                                            <tr>
                                              {" "}
                                              <th colSpan={4}>
                                                No Data Available
                                              </th>
                                            </tr>
                                          )}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                          <div
                            className="container"
                            style={{ maxWidth: "100%" }}
                          >
                            <div className="row">
                              <div className="col-lg-12">
                                {scrutinies && scrutinies?.length > 0 && (
                                  <form>
                                    <table
                                      className="table table-hover"
                                      id="myTable"
                                    >
                                      <thead>
                                        <tr>
                                          <th
                                            scope="col"
                                            className="text-center"
                                          >
                                            S.No
                                          </th>
                                          <th scope="col">Date</th>
                                          <th scope="col">Doc.No</th>
                                          <th scope="col">
                                            Particulars of deeds
                                          </th>
                                          <th scope="col">To Be Obtained</th>
                                          <th scope="col">Verified</th>
                                        </tr>
                                      </thead>
                                      <tbody className="scrity-table">
                                        {scrutinies &&
                                          scrutinies?.length > 0 &&
                                          scrutinies.map((scr, index) => {
                                            return (
                                              <tr
                                                className="pointer"
                                                key={index}
                                                style={{
                                                  background: scr.color,
                                                }}
                                              >
                                                <td
                                                  className="indexInput"
                                                  onClick={() =>
                                                    this.goToFile(scr)
                                                  }
                                                  style={{ fontSize: "16px" }}
                                                >
                                                  {index + 1}
                                                </td>
                                                <td
                                                  className="indexInput"
                                                  onClick={() =>
                                                    this.goToFile(scr)
                                                  }
                                                  style={{ fontSize: "16px" }}
                                                >
                                                  {scr.date}
                                                </td>
                                                <td
                                                  onClick={() =>
                                                    this.goToFile(scr)
                                                  }
                                                  style={{ fontSize: "16px" }}
                                                >
                                                  <a>{scr.doc_no}</a>
                                                </td>
                                                <td
                                                  onClick={() =>
                                                    this.goToFile(scr)
                                                  }
                                                  style={{ fontSize: "16px" }}
                                                >
                                                  {scr.particulars}
                                                </td>
                                                <td style={{ width: "15%" }}>
                                                  {this.state
                                                    .originalPresents &&
                                                    this.state.originalPresents
                                                      .length > 0 &&
                                                    this.state.originalPresents.map(
                                                      (opt: any) => {
                                                        opt.label = opt.name;
                                                        opt.value = opt.id;
                                                      }
                                                    ) && (
                                                      <Select
                                                        options={
                                                          this.state
                                                            .originalPresents
                                                        }
                                                        name="obtined"
                                                        className={
                                                          this.state.required &&
                                                          this.state.obtined ===
                                                            ""
                                                            ? "form-select is-invalid"
                                                            : "form-select"
                                                        }
                                                        value={this.state.originalPresents.find(
                                                          (o: any) =>
                                                            o.value ===
                                                            scr.vetting_nature_of_doc
                                                        )}
                                                        onChange={(e) =>
                                                          this.handleChangeobtained(
                                                            e,
                                                            index,
                                                            scr,
                                                            "obtainedstatus",
                                                            "singleselect"
                                                          )
                                                        }
                                                      />
                                                    )}
                                                </td>
                                                <td
                                                  className="indexInput text-center"
                                                  style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                  }}
                                                >
                                                  <input
                                                    type="checkbox"
                                                    className="form-control"
                                                    value=""
                                                    checked={
                                                      scr.remove_status === "1"
                                                    }
                                                    onChange={(event) =>
                                                      this.handleChangeremovestatus(
                                                        event,
                                                        scr
                                                      )
                                                    }
                                                  />
                                                </td>
                                              </tr>
                                            );
                                          })}
                                      </tbody>
                                    </table>
                                  </form>
                                )}

                                {this.state.allDocuments &&
                                  this.state.allDocuments.length > 0 && (
                                    <div className="col-md-4">
                                      <label className="bold">Document</label>
                                      {this.state.allDocuments.map(
                                        (opt: any) => {
                                          opt.label =
                                            opt.id +
                                            (opt.status == 1
                                              ? "- (Not Related)"
                                              : "");
                                          opt.value = opt.base_id;
                                        }
                                      ) && (
                                        <select
                                          className="custom-select"
                                          name="selectedDoc"
                                          value={this.state.selectedDoc}
                                          onChange={this.viewDocument}
                                          required
                                        >
                                          <option value="">Select</option>
                                          {this.state.allDocuments &&
                                          this.state.allDocuments.length
                                            ? this.state.allDocuments.map(
                                                (doc: any, index: number) => {
                                                  return (
                                                    <option
                                                      key={`${doc.id}|${index}`}
                                                      data-id={`${doc.value}|${index}`}
                                                      data-existing-status={
                                                        doc.existing_status
                                                      }
                                                      value={this.state.allDocuments.find(
                                                        (o: any) =>
                                                          o.value ===
                                                          this.state.selectedDoc
                                                      )}
                                                    >
                                                      {doc.label}
                                                    </option>
                                                  );
                                                }
                                              )
                                            : ""}
                                        </select>
                                      )}
                                    </div>
                                  )}

                                <div className="row">
                                  {!isEmpty(this.state.documentbase) && (
                                    <div className="col-md-5">
                                      <div className="mt-2">
                                        <button
                                          className="btn btn-square float-right"
                                          style={{
                                            color: "black",
                                            border: "1px solid black",
                                            borderRadius: "5px",
                                            height: "40px",
                                          }}
                                          onClick={() => {
                                            this.setState({
                                              documentbase: "",
                                              selectedDoc: "",
                                            });
                                          }}
                                        >
                                          Close
                                        </button>
                                        <iframe
                                          src={this.state.documentbase}
                                          width="100%"
                                          height={this.state.documentHeight}
                                        />
                                      </div>
                                    </div>
                                  )}
                                  <div
                                    className={`col-md-${
                                      !isEmpty(this.state.documentbase)
                                        ? "7"
                                        : "12"
                                    }`}
                                  >
                                    <div className="table mt-4">
                                      <div className="card-body table">
                                        <div className="dt-responsive table-responsive tablewidth">
                                          {this.state.columns &&
                                          this.state.columns.length ? (
                                            <>
                                              <label className="bold">
                                                Extra Table
                                              </label>
                                              <table className="table table-bordered table-hover">
                                                <thead>
                                                  <tr>
                                                    <th className="staticheder">
                                                      S.No
                                                    </th>
                                                    {columns.map(
                                                      (column, columnIndex) => (
                                                        <th
                                                          key={columnIndex}
                                                          className="staticheder"
                                                        >
                                                          {column}
                                                        </th>
                                                      )
                                                    )}
                                                    <th className="staticheder">
                                                      Action
                                                    </th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {rows.map(
                                                    (row: any, rowIndex) => (
                                                      <tr key={rowIndex}>
                                                        <td
                                                          style={{
                                                            width: "5%",
                                                          }}
                                                        >
                                                          {rowIndex +
                                                            this.state
                                                              .scrutinieLength +
                                                            1}
                                                        </td>
                                                        {row.cells.map(
                                                          (
                                                            cell,
                                                            columnIndex
                                                          ) => (
                                                            <td
                                                              key={columnIndex}
                                                              style={{
                                                                width: "35%",
                                                              }}
                                                            >
                                                              {row.isEditing ? (
                                                                <input
                                                                  type="text"
                                                                  className="form-control"
                                                                  value={cell}
                                                                  onChange={(
                                                                    event
                                                                  ) =>
                                                                    this.handleChangetable(
                                                                      event,
                                                                      rowIndex,
                                                                      columnIndex
                                                                    )
                                                                  }
                                                                />
                                                              ) : (
                                                                <span
                                                                  style={{
                                                                    fontSize:
                                                                      "16px",
                                                                  }}
                                                                >
                                                                  {cell}
                                                                </span>
                                                              )}
                                                            </td>
                                                          )
                                                        )}
                                                        <td
                                                          style={{
                                                            width: "5%",
                                                          }}
                                                        >
                                                          <div
                                                            className="d-flex justify-content-center align-items-center"
                                                            style={{
                                                              gap: "15px",
                                                              fontSize: "20px",
                                                            }}
                                                          >
                                                            {row.isEditing ? (
                                                              <>
                                                                <i
                                                                  title="Save"
                                                                  style={{
                                                                    color:
                                                                      "green",
                                                                  }}
                                                                  className="fas fa-save cursor-pointer"
                                                                  onClick={() =>
                                                                    this.handleSaveRow(
                                                                      rowIndex
                                                                    )
                                                                  }
                                                                ></i>
                                                                <i
                                                                  title="Cancel"
                                                                  style={{
                                                                    color:
                                                                      "red",
                                                                  }}
                                                                  className="fas fa-times cursor-pointer"
                                                                  onClick={() =>
                                                                    this.handleCancelEdit(
                                                                      rowIndex
                                                                    )
                                                                  }
                                                                ></i>
                                                              </>
                                                            ) : (
                                                              <>
                                                                <i
                                                                  title="Edit"
                                                                  style={{
                                                                    color:
                                                                      "blue",
                                                                  }}
                                                                  className="fas fa-edit cursor-pointer"
                                                                  onClick={() =>
                                                                    this.handleEditRow(
                                                                      rowIndex
                                                                    )
                                                                  }
                                                                ></i>
                                                                <i
                                                                  title="Delete"
                                                                  style={{
                                                                    color:
                                                                      "red",
                                                                  }}
                                                                  className="fas fa-trash cursor-pointer"
                                                                  onClick={() =>
                                                                    this.handleRemoveRow(
                                                                      rowIndex
                                                                    )
                                                                  }
                                                                ></i>
                                                              </>
                                                            )}
                                                          </div>
                                                        </td>
                                                      </tr>
                                                    )
                                                  )}
                                                </tbody>
                                              </table>
                                              {isShowButton && (
                                                <button
                                                  onClick={this.handleAddRow}
                                                  className="btn btn-primary pull-left"
                                                >
                                                  <i className="fas fa-plus mr-1"></i>{" "}
                                                  Add Row
                                                </button>
                                              )}
                                            </>
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  className="file-search-button formbtn d-flex float-right"
                                  style={{ marginTop: "0%" }}
                                >
                                  {this.state.info.qaStatus == 1 && (
                                    <>
                                      <button
                                        onClick={() => {
                                          this.scrutinyReport();
                                        }}
                                        className="btn btn-square float-right"
                                        style={{
                                          color: "black",
                                          border: "1px solid black",
                                          borderRadius: "5px",
                                          height: "40px",
                                          marginTop: "3%",
                                        }}
                                      >
                                        Overview
                                      </button>
                                      {String(this.state.info.vetting_download_button) === "1" && (
                                        <button
                                          type="button"
                                          className="btn btn-square float-right"
                                          disabled={!this.state.docxReady}
                                          onClick={this.downloadGeneratedDocx}
                                          title={
                                            this.state.docxReady
                                              ? "Download the generated Word document"
                                              : "Available after Overview generates the Word document"
                                          }
                                          style={{
                                            color: this.state.docxReady
                                              ? "black"
                                              : "#6c757d",
                                            border: "1px solid black",
                                            borderRadius: "5px",
                                            height: "40px",
                                            marginTop: "3%",
                                            marginLeft: "8px",
                                            cursor: this.state.docxReady
                                              ? "pointer"
                                              : "not-allowed",
                                            opacity: this.state.docxReady ? 1 : 0.55,
                                          }}
                                        >
                                          Download
                                        </button>
                                      )}
                                    </>
                                  )}
                                  {isShowButton && (
                                    <>
                                      <button
                                        className="btn btn-square float-right"
                                        style={{
                                          color: "black",
                                          border: "1px solid black",
                                          borderRadius: "5px",
                                          height: "40px",
                                          marginTop: "3%",
                                        }}
                                        onClick={() => {
                                          if (this.state.hasUnsavedChanges) {
                                            const confirmLeave = window.confirm(
                                              "If you have unsaved changes. Do you want to leave without saving?"
                                            );
                                            if (!confirmLeave) {
                                              return;
                                            }
                                          }

                                          if (
                                            this.state.sop_status == 1 &&
                                            this.state.docList &&
                                            this.state.docList.length > 0
                                          ) {
                                            const activeDocsLength =
                                              this.state.docList.filter(
                                                (doc: any) => doc.inactive == 0
                                              ).length;
                                            const savedDocsLength =
                                              this.state.docList.filter(
                                                (doc: any) =>
                                                  doc.submit == 1 &&
                                                  doc.inactive == 0
                                              ).length;
                                            const isValid =
                                              activeDocsLength ==
                                              savedDocsLength;
                                            if (!isValid) {
                                              ToastsStore.error(
                                                "Please type all SOP documents"
                                              );
                                              return;
                                            }
                                          }

                                          this.props.history.push({
                                            pathname:
                                              "/vettingwork-file-qa/" +
                                              this.props.match.params.id,
                                            state: {
                                              hash: "Vetting",
                                              isVetting: true,
                                            },
                                            hash: "#Vetting",
                                          });
                                        }}
                                      >
                                        Work File Q & A
                                      </button>
                                      <button
                                        type="submit"
                                        className="btn btn-primary"
                                        onClick={this.handleSubmit}
                                        style={{
                                          height: "40px",
                                          marginTop: "3%",
                                        }}
                                      >
                                        Save
                                      </button>
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="text-center loader"
                            style={{
                              display: "none",
                              border: "none",
                              marginTop: "2%",
                            }}
                          >
                            <h4>
                              <span>Loading... {timer} seconds</span>
                            </h4>
                          </div>

                          <div
                            ref={this.scrollToRef}
                            className="pdfcontainer"
                            style={{ width: "100%" }}
                          >
                            <div style={{ marginTop: "1%" }} />
                            {this.state.report && (
                              <div>
                                <div className="row justify-content-between m-auto">
                                  {/* <button
                                  type="button"
                                  id="test"
                                  className="btn btn-primary"
                                  onClick={this.downloadDocs}
                                >
                                  Download Doc <i className="fa fa-download" />
                                </button> */}
                                  {this.state.report && isShowButton && (
                                    <>
                                      <button
                                        type="submit"
                                        className="btn btn-success float-right"
                                        data-toggle="modal"
                                        data-target="#vetting-complete"
                                        style={{
                                          height: "40px",
                                          marginTop: "5px",
                                        }}
                                        disabled={!this.state.enableComplete}
                                      >
                                        Vetting Complete
                                      </button>
                                      {/* <a
                                      href={this.state.download_report}
                                      download
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="btn btn-primary float-right"
                                      style={{ height: "40px", marginTop: "5px", marginRight: "10px" }}
                                    >
                                      Download Docx
                                    </a> */}
                                    </>
                                  )}
                                </div>
                                <TabKeyBlocker scopeToContainer={true}>

                                  <div className="iframe-container">
                                    <iframe
                                      src={this.state.report}
                                      width="100%"
                                      height="600"
                                      frameBorder="0"
                                    >
                                      This is an embedded Word document.
                                    </iframe>
                                    <div className="top-overlay"></div>
                                    <div className="bottom-overlay"></div>
                                  </div>
                                </TabKeyBlocker>
                              </div>
                            )}
                          </div>
                        </>
                      )}

                    <div
                      className="modal fade bd-example-modal-lg"
                      id="upload-modal"
                      tabIndex={-1}
                      role="dialog"
                      aria-hidden="true"
                    >
                      <div
                        className="modal-dialog"
                        style={{ maxWidth: "1400px" }}
                        role="document"
                      >
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title">Upload File</h5>
                            <button
                              type="button"
                              className="close"
                              data-dismiss="modal"
                              aria-label="Close"
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div className="modal-body">
                            <div className="text-right">
                              <button
                                type="button"
                                className="btn btn-primary btn-sm upload-document-button"
                                onClick={() => this.addUploadDocument()}
                              >
                                Add Document +
                              </button>
                            </div>
                            {this.state.base.length > 0 &&
                              this.state.base.map((document, index) => (
                                <DashUploadDocument
                                  baseDetails={document}
                                  handleDocumentDetailsChange={
                                    this.handleDocumentDetailsChange
                                  }
                                  handleDocumentFilesChange={
                                    this.handleDocumentFilesChange1
                                  }
                                  deleteDocumentDetails={
                                    this.deleteDocumentDetails
                                  }
                                  deleteFile={this.deleteFile}
                                  deedList={this.state.deeds}
                                  previewDoc={this.previewDoc}
                                  categoriesList={this.state.categoriesList}
                                  index={index}
                                  newfile={this.state.isNewFile}
                                  state={this.state}
                                  path="filedashboard"
                                  isbtnload={this.state.isbtnload}
                                />
                              ))}
                            <div
                              className="modal-footer"
                              style={{ border: "none" }}
                            >
                              <div style={{ margin: "auto" }}>
                                {this.state.base.length > 0 && (
                                  <>
                                    <button
                                      type="button"
                                      className="btn btn-secondary"
                                      data-dismiss="modal"
                                      onClick={this.closeuploadfile}
                                    >
                                      Cancel
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-primary"
                                      style={{ margin: "auto" }}
                                      // data-dismiss="modal"
                                      disabled={this.state.uploadbtn == true}
                                      onClick={(e) =>
                                        this.validateRequiredFileds(e)
                                      }
                                    >
                                      {this.state.isbtnload && (
                                        <i className="fa fa-spinner fa-spin"></i>
                                      )}
                                      Confirm
                                    </button>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className={`modal ${this.state.previewDoc ? "open" : ""}`}
                      id="preview-document"
                      role="dialog"
                      aria-hidden={this.state.previewDoc === ""}
                      {...(this.state.previewDoc === "" && { inert: "" })}
                    >
                      <div
                        className="modal-dialog modal-lg"
                        role="document"
                        style={{ maxWidth: "1400px" }}
                      >
                        <div
                          className="modal-content"
                          style={{ height: "90vh" }}
                        >
                          <div className="modal-header">
                            <h5 className="modal-title">Document Preview</h5>
                            <button
                              type="button"
                              className="close cursor-pointer"
                              data-dismiss="modal"
                              aria-label="Close"
                              onClick={() => this.setState({ previewDoc: "" })}
                            >
                              <span aria-hidden={this.state.previewDoc === ""}>
                                &times;
                              </span>
                            </button>
                          </div>
                          <div className="modal-body">
                            <iframe
                              width="100%"
                              height="100%"
                              src={this.state.previewDoc}
                            ></iframe>
                          </div>
                          <div className="modal-footer">
                            <button
                              type="button"
                              className="btn btn-secondary"
                              data-dismiss="modal"
                              onClick={() => this.setState({ previewDoc: "" })}
                            >
                              Close
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* REASON MODAL */}
                    <div
                      className="modal hide fade in"
                      id="modal-reason"
                      data-backdrop="static"
                      data-keyboard="false"
                    >
                      <div className="modal-dialog ">
                        <div
                          className="modal-content"
                          style={{
                            borderRadius: "10px",
                            boxShadow: "0 0 15px #000",
                          }}
                        >
                          <h5
                            style={{
                              marginTop: "31px",
                              textAlign: "center",
                            }}
                          >
                            Please Type a Reason To Edit{" "}
                          </h5>
                          <div
                            className="modal-body"
                            style={{ padding: "30px 23px 29px 24px" }}
                          >
                            <div
                              className="form-group"
                              style={{ width: "98%", margin: "auto" }}
                            >
                              <textarea
                                className="form-control"
                                placeholder="Type Your Reason"
                                name="outreason"
                                value={this.state.outreason}
                                onChange={this.onchange}
                              />
                              {ReasonVal ? (
                                <p
                                  style={{
                                    color: "red",
                                    textAlign: "center",
                                    fontSize: "16px",
                                  }}
                                >
                                  Please Enter Your Reason{" "}
                                </p>
                              ) : null}
                            </div>
                          </div>
                          <div className="modal-footer">
                            <button
                              type="button"
                              className="btn btn-primary"
                              onClick={() => this.ReasonUpdate()}
                              style={{ width: "76px", fontSize: "17px" }}
                            >
                              {" "}
                              Ok
                            </button>
                            <button
                              type="button"
                              className="btn btn-outline"
                              onClick={() => this.closeModal()}
                              style={{
                                width: "76px",
                                fontSize: "17px",
                                border: "1px solid black",
                              }}
                            >
                              {" "}
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="modal hide fade in"
                      id="processComplete"
                      data-backdrop="static"
                      data-keyboard="false"
                    >
                      <div className="modal-dialog ">
                        <div
                          className="modal-content"
                          style={{
                            borderRadius: "10px",
                            boxShadow: "0 0 15px #000",
                          }}
                        >
                          <div className="modal-body">
                            <h5 style={{ textAlign: "center" }}>
                              {" "}
                              Thanks For Complete Your File:
                              {this.props.match.params.id}
                            </h5>
                          </div>
                          <div className="modal-footer">
                            {showTitle ? null : (
                              <button
                                type="button"
                                className="btn btn-success"
                                onClick={() => this.close()}
                                // onClick={this.disableModalHandler}
                                style={{
                                  width: "50%",
                                  fontSize: "17px",
                                  margin: "auto",
                                }}
                              >
                                {" "}
                                Ok
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="modal fade"
                      id="vetting-complete"
                      role="dialog"
                      aria-hidden="true"
                    >
                      <div className="modal-dialog" role="document">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5
                              className="modal-title"
                              style={{ textAlign: "center" }}
                            >
                              Vetting Completed
                            </h5>
                            <button
                              type="button"
                              className="close"
                              data-dismiss="modal"
                              aria-label="Close"
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div className="modal-body">
                            {vettingStatus && (
                              <h6>
                                Your vetting report is completed please contact
                                our support team
                              </h6>
                            )}

                            {!vettingStatus && (
                              <>
                                <h6>
                                  Are you sure you want to complete the vetting
                                  report ?
                                </h6>
                                <div className="form-group"></div>
                              </>
                            )}
                          </div>
                          {!vettingStatus && (
                            <div className="modal-footer">
                              <button
                                type="button"
                                className="btn btn-success"
                                disabled={this.state.completeLoading}
                                onClick={() =>
                                  this.updateBillVettingComplete(2)
                                }
                              >
                                {this.state.completeLoading ? (
                                  <i className="fa fa-spinner fa-spin"></i>
                                ) : (
                                  "Yes"
                                )}
                              </button>
                              <button
                                type="button"
                                className="btn btn-danger"
                                data-dismiss="modal"
                              >
                                No
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div
                      className="modal fade"
                      id="holdModal"
                      tabIndex={-1}
                      role="dialog"
                      aria-labelledby="exampleModalLabel"
                      aria-hidden="true"
                    >
                      <div className="modal-dialog" role="document">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5>
                              Are you sure you want to hold{" "}
                              {this.state.info.file_name}?
                            </h5>
                          </div>
                          {this.state.holdVal && (
                            <>
                              <div className="modal-body">
                                <p
                                  style={{
                                    textAlign: "center",
                                    color: "black",
                                  }}
                                >
                                  Please Type a Reason To hold The File
                                </p>
                                <div
                                  className="form-group"
                                  style={{ width: "98%", margin: "auto" }}
                                >
                                  <textarea
                                    className="form-control"
                                    placeholder="Type Your Reason"
                                    name="holdreason"
                                    onChange={this.onchange}
                                  />
                                  {isEmpty(this.state.holdreason) ? (
                                    <p
                                      style={{
                                        color: "red",
                                        textAlign: "center",
                                        fontSize: "16px",
                                      }}
                                    >
                                      Please type your reason{" "}
                                    </p>
                                  ) : null}
                                </div>
                              </div>
                            </>
                          )}
                          <div className="modal-footer">
                            <button
                              type="button"
                              className="btn btn-secondary"
                              data-dismiss="modal"
                            >
                              No
                            </button>
                            <button
                              type="button"
                              className="btn btn-primary"
                              onClick={() => this.holdFile()}
                            >
                              {this.state.isLoading ? (
                                <i className="fa fa-spinner fa-spin"></i>
                              ) : (
                                "Yes"
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      //   </div>
      // </div>
    );
  }
}
